import { makeStyles } from '@mui/styles';
import { COLOR_GRAY_70, COLOR_PINK } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  title: {
    color: COLOR_GRAY_70,
    fontFamily: 'Lato',
    fontSize: 19,
    fontWeight: 700,
    lineHeight: '24px',

    '& b': {
      color: COLOR_PINK,
    },
  },
  sideCard: {
    '& li': {
      fontSize: 16,
      color: COLOR_GRAY_70,
      display: 'flex',
      alignItems: 'center',
      gap: 4,
    },
    '& ul': {
      listStyle: 'none',
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
    },
    '& button': {
      margin: theme.spacing(2, 0),
      width: '100%',
    },
  },
  btnLoginMobile: {
    backgroundColor: COLOR_PINK,
  },
  checkIcon: {
    height: 16,
    width: 16,
    color: COLOR_PINK,
  },
}));
